import React from 'react';
import UnifiedPortalShell from '../components/layout/UnifiedPortalShell';
import SupportChatWidget from './components/SupportChatWidget';

const CANDIDATE_NAV = [
  { to: '/candidate', label: 'Dashboard', icon: 'dashboard', end: true },
  { to: '/candidate/openings', label: 'Job Openings', icon: 'openings' },
  { to: '/candidate/applications', label: 'My Applications', icon: 'applications' },
  { to: '/candidate/interviews', label: 'My Interviews', icon: 'interviews' },
  { to: '/candidate/practice', label: 'Practice', icon: 'practice' },
  { to: '/candidate/profile', label: 'Profile', icon: 'profile' },
  { to: '/candidate/settings', label: 'Settings', icon: 'settings' },
];

export default function CandidatePortalShell() {
  return (
    <>
      <UnifiedPortalShell
        portalType="candidate"
        navItems={CANDIDATE_NAV}
        brandSubtitle="CANDIDATE PORTAL"
        breadcrumbPrefix="Candidate Portal"
      />
      {/* Help chatbot, bottom-left on every candidate page */}
      <SupportChatWidget />
    </>
  );
}
